import { render, staticRenderFns } from "./Advisors.vue?vue&type=template&id=3a0b9bce&scoped=true&"
import script from "./Advisors.vue?vue&type=script&lang=js&"
export * from "./Advisors.vue?vue&type=script&lang=js&"
import style0 from "./Advisors.vue?vue&type=style&index=0&id=3a0b9bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0b9bce",
  null
  
)

export default component.exports